"use client";

import { Toaster } from "sonner";

/**
 * The app's single `<Toaster>` configuration.
 *
 * Rendered by the root layout AND by the Storybook wrapper, so a toast looks
 * the same in both. It used to be configured inline in the layout while
 * Storybook mounted a bare `<Toaster position="top-center" />` — no
 * `richColors`, so every error toast reviewed in Storybook was a plain white
 * box rather than the red one customers actually see, and no `closeButton`.
 *
 * Import `toast` from `@/lib/toast` (never `sonner` directly) so the Sentry /
 * Mixpanel / OTel fan-out stays intact — see `.claude/rules/web/analytics.md`.
 */
export function AppToaster() {
  return (
    <Toaster
      className="!text-center"
      position="top-center"
      richColors
      closeButton
      toastOptions={{
        duration: 5000,
        classNames: {
          content: "lg:!text-base !text-center !w-full",
          // toast: "lg:!w-[420px] !text-center",
        },
      }}
    />
  );
}
